import { Model } from 'dva'
import { OrganisationsService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const UtteranceContent: Model = {
  namespace: 'utteranceContent',
  state: {
    list: [],
  },
  effects: {
    *list(
      { id, useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      const organisationUuid = yield select(
        (state: any) => state.flowLayout.flow?.organisation?.uuid
      )
      const flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
      let flowConfigVersion = yield select((state: any) => state.flowLayout?.version?.version)
      try {
        const response = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesContentsList,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            utterancePk: id,
          }
        )
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err: any) {
        FailureHandler('Error fetching Utterance Contents', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { utteranceId, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      const organisationUuid = yield select(
        (state: any) => state.flowLayout.flow?.organisation?.uuid
      )
      const flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
      const flowConfigVersion = yield select((state: any) => state.flowLayout.version?.version)
      try {
        const response = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesContentsRetrieve,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            id: id,
            utterancePk: utteranceId,
          }
        )
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Could not find the Utterance Content!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { utteranceId, data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      const organisationUuid = yield select(
        (state: any) => state.flowLayout.flow?.organisation?.uuid
      )
      const flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
      const flowConfigVersion = yield select((state: any) => state.flowLayout.version?.version)
      try {
        const response = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesContentsCreate,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            requestBody: data,
            utterancePk: utteranceId,
          }
        )
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a Utterance Content!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, utteranceId, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      const organisationUuid = yield select(
        (state: any) => state.flowLayout.flow?.organisation?.uuid
      )
      const flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
      const flowConfigVersion = yield select((state: any) => state.flowLayout.version?.version)
      try {
        const response = yield call(
          OrganisationsService.organisationsFlowsVersionsUserUtterancesContentsPartialUpdate,
          {
            organisationUuid,
            flowUuid,
            flowConfigVersion,
            id: id,
            utterancePk: utteranceId,
            requestBody: data,
          }
        )
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a Utterance Content!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      {
        utteranceId,
        idParentAlias,
        id,
        setLoading = () => {},
        onSuccess = () => {},
        onFailure = () => {},
      },
      { call, put, select }
    ): any {
      setLoading(true)
      const organisationUuid = yield select(
        (state: any) => state.flowLayout.flow?.organisation?.uuid
      )
      const flowUuid = yield select((state: any) => state.flowLayout.flow?.uuid)
      const flowConfigVersion = yield select((state: any) => state.flowLayout.version?.version)
      try {
        yield call(OrganisationsService.organisationsFlowsVersionsUserUtterancesContentsDestroy, {
          organisationUuid,
          flowUuid,
          flowConfigVersion,
          id: id,
          utterancePk: idParentAlias,
        })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a Utterance Content', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: any) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: any) => !action.payload.map((p: any) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: any) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetUtteranceContent(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default UtteranceContent
